<template>
	<ListSelector pk="key" :items="formulasData" v-bind="$attrs" @selectItem="selectItem" class="formula-selector-main">
		<template #item-content="{ item }">
			<AppTooltip position="left" :text="item.tooltip" :nudge-left="item.icon ? 55 : 5" v-if="item.tooltip">
				<FormulaTitle :title="item.title" />
			</AppTooltip>
			<FormulaTitle :title="item.title" v-else />
		</template>
	</ListSelector>
</template>

<script>
import FormulaTitle from './FormulaTitle';
import { FORMULAS } from '../../common/RichTextBox/FormulaChip/formulas.const';
import AppTooltip from '@/components/common/AppTooltip';
import ListSelector from '@/components/common/ListSelector/ListSelector.vue';

export default {
	name: 'FormulaSelector',
	props: {
		formulas: { type: Array },
	},
	components: { ListSelector, AppTooltip, FormulaTitle },
	computed: {
		formulasData() {
			return FORMULAS.filter((formula) => this.formulas.includes(formula.id));
		},
	},
	methods: {
		selectItem(...args) {
			this.$emit('on-formula-selected', ...args);
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep {
	.list-item-container {
		border: none !important;
		padding: 3px 10px !important;

		.item-content:hover {
			background: transparent;
		}
	}
}
</style>
